import React, { Component } from 'react';

interface NotFoundProps {}

interface NotFoundState {}

class NotFound extends Component<NotFoundProps, NotFoundState> {
    render() {
        return <><h1>Not Found</h1></>
    }
}

export default NotFound;